module.exports = __webpack_public_path__ + "static/media/cloud-computing.37dea6ea.svg";